<script setup lang="ts">
import { watch, ref } from 'vue'
import { useRoute } from 'vue-router';
import router from '@/router';
import { useStore } from 'vuex';

const store = useStore();
const route = useRoute();
const currentPath = ref<string>('')

function navButtonClick(buttonId: string) {
  switch (buttonId) {
    case 'main': 
      router.push('/');
      break;
    case 'zagotovki':
      router.push('/work_pieces')
      break;
    case 'settings': 
      router.push('/settings');
      break;
    default: 
      break;
  }
}

watch(() => route.path, (newVal) => {
  console.log('newVal=', newVal)
  switch (newVal) {
    case '/': 
      currentPath.value = '/'
      break;
      case '/work_pieces':
        currentPath.value = '/work_pieces'
        break;
      case '/settings': 
        currentPath.value = '/settings'
      break;
      case '/workers': 
        currentPath.value = '/settings'
      break;
    default: 
      break;
  }
}, {immediate: true})

</script>

<template>

  <div class="nav-bar">
  <button 
    type="button"
    class="nav-bar__button"
    @click="navButtonClick('main')"
    :style="{ opacity: currentPath === '/' ? '1' : '.4' }"
    >
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.75 16.75H7.75M0.75 10.9539C0.75 8.66549 0.75 7.52128 1.2692 6.57274C1.7884 5.62421 2.73695 5.03551 4.63403 3.85813L6.63403 2.61687C8.63939 1.37229 9.6421 0.75 10.75 0.75C11.8579 0.75 12.8606 1.37229 14.866 2.61687L16.866 3.85812C18.7631 5.03551 19.7116 5.62421 20.2308 6.57274C20.75 7.52128 20.75 8.66549 20.75 10.9539V12.475C20.75 16.3758 20.75 18.3263 19.5784 19.5381C18.4069 20.75 16.5212 20.75 12.75 20.75H8.75C4.97876 20.75 3.09315 20.75 1.92157 19.5381C0.75 18.3263 0.75 16.3758 0.75 12.475V10.9539Z" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
    <p class="label">
      Главная
    </p>
  </button>
  <button 
    type="button"
    class="nav-bar__button"
    @click="navButtonClick('zagotovki')"
    :style="{ opacity: currentPath === '/work_pieces' ? '1' : '.4' }"
    >
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.75 6.25L15.75 8.25M15.75 8.25L15.25 8.5L10.75 10.75M15.75 8.25V11.75M15.75 8.25L6.25 3.25M10.75 10.75L1.75 6.25M10.75 10.75V20.25M14.3277 2.13197L16.3277 3.18152C18.4794 4.31066 19.5552 4.87523 20.1526 5.88974C20.75 6.90425 20.75 8.16667 20.75 10.6915V10.8085C20.75 13.3333 20.75 14.5958 20.1526 15.6103C19.5552 16.6248 18.4794 17.1893 16.3277 18.3185L14.3277 19.368C12.5721 20.2893 11.6943 20.75 10.75 20.75C9.8057 20.75 8.9279 20.2893 7.17229 19.368L5.17229 18.3185C3.02063 17.1893 1.94479 16.6248 1.3474 15.6103C0.75 14.5958 0.75 13.3333 0.75 10.8085V10.6915C0.75 8.16667 0.75 6.90425 1.3474 5.88974C1.94479 4.87523 3.02063 4.31066 5.17229 3.18152L7.17229 2.13197C8.9279 1.21066 9.8057 0.75 10.75 0.75C11.6943 0.75 12.5721 1.21066 14.3277 2.13197Z" stroke="black" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
    <p class="label">
      Заготовки
    </p>
  </button>
  <button v-if="store.getters.USER.role === 'admin'"
    type="button"
    class="nav-bar__button"
    @click="navButtonClick('settings')"
    :style="{ opacity: currentPath === '/settings' ? '1' : '.4' }"
    >
    <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9436 0.90224C11.576 0.75 11.1101 0.75 10.1782 0.75C9.24632 0.75 8.78042 0.75 8.41282 0.90224C7.92279 1.10523 7.53344 1.49458 7.33045 1.98463C7.23779 2.20834 7.20152 2.4685 7.18733 2.84799C7.16648 3.40568 6.88048 3.92189 6.39716 4.20093C5.91386 4.47996 5.32381 4.46954 4.83041 4.20876C4.49467 4.0313 4.25123 3.93262 4.01116 3.90102C3.48526 3.83178 2.9534 3.97429 2.53258 4.2972C2.21696 4.53938 1.98399 4.9429 1.51805 5.74993C1.05211 6.55697 0.81914 6.96048 0.76721 7.35491C0.69798 7.8808 0.84049 8.41266 1.1634 8.8335C1.31078 9.0256 1.51792 9.187 1.83941 9.389C2.31202 9.686 2.61611 10.1919 2.61608 10.75C2.61605 11.3081 2.31197 11.8139 1.8394 12.1108C1.51787 12.3129 1.3107 12.4744 1.1633 12.6665C0.84039 13.0873 0.69788 13.6191 0.76712 14.145C0.81904 14.5394 1.05201 14.943 1.51795 15.75C1.9839 16.557 2.21687 16.9606 2.53248 17.2027C2.9533 17.5256 3.48516 17.6681 4.01106 17.5989C4.25111 17.5673 4.49454 17.4686 4.83026 17.2912C5.32369 17.0304 5.91378 17.02 6.39712 17.299C6.88046 17.5781 7.16648 18.0943 7.18733 18.6521C7.20153 19.0315 7.23779 19.2917 7.33045 19.5154C7.53344 20.0054 7.92279 20.3948 8.41282 20.5978C8.78042 20.75 9.24632 20.75 10.1782 20.75C11.1101 20.75 11.576 20.75 11.9436 20.5978C12.4336 20.3948 12.823 20.0054 13.0259 19.5154C13.1186 19.2917 13.1549 19.0315 13.1691 18.652C13.1899 18.0943 13.4759 17.5781 13.9592 17.299C14.4425 17.0199 15.0326 17.0304 15.5261 17.2912C15.8618 17.4686 16.1052 17.5672 16.3452 17.5988C16.8711 17.6681 17.403 17.5256 17.8238 17.2027C18.1394 16.9605 18.3724 16.557 18.8383 15.7499C19.3043 14.9429 19.5373 14.5394 19.5892 14.145C19.6584 13.6191 19.5159 13.0872 19.193 12.6664C19.0456 12.4743 18.8384 12.3128 18.5169 12.1108C18.0444 11.8139 17.7403 11.308 17.7403 10.7499C17.7403 10.1918 18.0444 9.6861 18.5169 9.3892C18.8385 9.1871 19.0457 9.0257 19.1931 8.8335C19.516 8.41273 19.6585 7.88087 19.5893 7.35497C19.5374 6.96055 19.3044 6.55703 18.8384 5.75C18.3725 4.94297 18.1395 4.53945 17.8239 4.29727C17.4031 3.97436 16.8712 3.83185 16.3453 3.90109C16.1053 3.93269 15.8619 4.03136 15.5261 4.2088C15.0327 4.46959 14.4426 4.48002 13.9593 4.20096C13.4759 3.92191 13.1899 3.40566 13.1691 2.84794C13.1549 2.46848 13.1186 2.20833 13.0259 1.98463C12.823 1.49458 12.4336 1.10523 11.9436 0.90224Z" stroke="black" stroke-width="1.5"/>
      <path d="M10.1777 13.75C11.8346 13.75 13.1777 12.4069 13.1777 10.75C13.1777 9.09315 11.8346 7.75 10.1777 7.75C8.52088 7.75 7.17773 9.09315 7.17773 10.75C7.17773 12.4069 8.52088 13.75 10.1777 13.75Z" stroke="black" stroke-width="1.5"/>
    </svg>
    <p class="label">
      Настройки
    </p>
  </button>

  </div>

</template>

<style scoped>

.label {
  color: black;
  font-size: 12px;
}

.nav-bar__button {
  border: none;
  outline: none;
  cursor: pointer;
  padding: 0;
  background: none;
  font-family: inherit;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  position: relative;
  transition: all .3s ease-in-out;
}

.nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  background-color: white;
  box-sizing: border-box;
  border-top-left-radius: var(--border-radius);
  border-top-right-radius: var(--border-radius);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 20px 0 25px 0;
  box-shadow: var(--drop-shadow-item);
}

</style>